import  { useEffect, useState } from 'react';
import apiService from '../../../services/api.service';
import { useHistory } from 'react-router-dom';

const AttendanceManager = ({ eventId, eventStatus }) => {
    const [attendanceStarted, setAttendanceStarted] = useState(false);
    const history = useHistory();

    useEffect(() => {
        setAttendanceStarted(eventStatus === 'active');
    }, [eventStatus]);

    useEffect(() => {
        if (!attendanceStarted) return;

        apiService.sendAttendance(eventId);

        const sendAttendanceInterval = setInterval(() => {
            apiService.sendAttendance(eventId)
                .catch(() => {
                    localStorage.setItem('authError', "true")
                    history.go(0);
                })
        }, 5 * 60 * 1000);

        return () => { clearInterval(sendAttendanceInterval) }
    }, [attendanceStarted, eventId, history])

    return null
};

export default AttendanceManager;
